function printDiv() {
    var divContents1 = document.getElementById('printdate').innerHTML;
    var divContents2 = document.getElementById('congemater').innerHTML;
    var divContents = document.getElementById('impressionpdf').innerHTML;
    var a = window.open('', '', 'height=500, width=500');

    a.document.write(
        '<style>@font-face{font-family: "Manuscrit";font-display: swap;src:url(\'https://cdn.shopify.com/s/files/1/0045/2244/2786/files/manuscrit.woff?v=1664372486\') format("woff2"),       url(\'https://cdn.shopify.com/s/files/1/0045/2244/2786/files/manuscrit.woff2?v=1664372485\') format("woff");}.handwritten {font-family : "Manuscrit", serif !important;font-size:1.8rem !important;line-height:1.6 !important;font-weight: 100 !important;margin-top:0.8em !important;text-align:center !important;max-width:500px;margin:auto;display: block;margin-bottom: 0 !important;}#calendrierconge {border:solid 1px #000;text-align: center;}#calendriersemaine td {border:solid 1px #000;border-spacing: 0px;text-align:center;}#calendrierconge {border-spacing:0px;max-width:600px;margin:auto;}#calendrierconge th {font-family: \'Playfair Display\',serif;font-weight: 700;fontsize:150%;}#calendrierconge td, #calendrierconge th {border:solid 2px #000; padding:2px;text-align: center;}.nbgrossesse{font-family: \'Playfair Display\',serif;font-weight: 700;font-size:220%;text-align: center;margin:auto;}.grossesse{font-family : "Manuscrit", serif !important;font-size:2.5rem !important;line-height:1.4 !important;font-weight: 100 !important;margin-top:0.8em !important;text-align:center !important;}@media print {@page {size: A4; margin:15px;margin-top:40px;}}.sautligne{page-break-before: always;}table#calendriersemaine{height:80%!important; width:auto;font-size:11px;border-spacing: 0px;}</style>'
    );
    a.document.write(`<div id="titrepage">
    <h2 class="grossesse" style="margin-bottom: -10px !important;">Télécharger les dates importantes de ma grossesse</h2>
    <center>par <img style="margin-bottom: -3px;" src="https://cdn.shopify.com/s/files/1/0045/2244/2786/files/logonoirsmall.png" width="40px"></center></div>`);
    a.document.write(divContents1);
    a.document.write('<br><br><br>');
    a.document.write(divContents2);
    a.document.write('<br><br><br>');
    a.document.write(divContents);
    a.document.close();
    a.print();
}

function dispDate(dateObj) {
    month = dateObj.getMonth() + 1;
    month = month < 10 ? '0' + month : month;

    day = dateObj.getDate();
    day = day < 10 ? '0' + day : day;

    year = dateObj.getYear();
    if (year < 2000) year += 1900;

    return day + '/' + month + '/' + year;
}

function grossesseElia(pregform) {
    menstrual = new Date();
    ovulation = new Date();
    duedate = new Date();
    today = new Date();
    cycle = 0;
    luteal = 0;
    var multipleg = pregform.gmultiple.value;
    var pariteg = pregform.gparite.value;
    var evenement = pregform.event.value;
    var date = new Date(pregform.date.value);
    var day = date.getDate();
    var month = date.getMonth();
    var year = date.getFullYear();

    menstrualinput = new Date(year, month, day);
    menstrual.setTime(menstrualinput.getTime());

    cycle = pregform.cycle.value == '' ? 28 : pregform.cycle.value; // defaults to 28
    // validates cycle range, from 22 to 45
    if (pregform.cycle.value != '' && (pregform.cycle.value < 22 || pregform.cycle.value > 45)) {
        alert('Veuillez rentrer une durée de cycle valable');
    }

    luteal = 14; // defaults to 14

    // date ovulation : DDR + cycle - phase lutéale

    if (evenement == "DOV") {
        ovulation.setTime(menstrual.getTime());

    }
    else if (evenement == "DDR") {
        ovulation.setTime(menstrual.getTime() + (cycle * 86400000) - (luteal * 86400000));

    }
    else if (evenement == "DCON") {
        ovulation.setTime(menstrual.getTime() + (2 * 86400000));
    }
    else if (evenement == "DINS") {
        ovulation.setTime(menstrual.getTime());
    }
    else if (evenement == "DJ3") {
        ovulation.setTime(menstrual.getTime() - (3 * 86400000));

    }
    else {
        ovulation.setTime(menstrual.getTime() - (5 * 86400000));

    }

    document.getElementById('conception').innerHTML = dispDate(ovulation);

    // date d'accouchement : date dovulation + 266j

    if (multipleg == '2E') {
        duedate.setTime(ovulation.getTime() + (266 - 21) * 86400000);
    } else if (multipleg == '3E') {
        duedate.setTime(ovulation.getTime() + (266 - 21 - 14) * 86400000);
    } else if (pariteg != '0P') {
        duedate.setTime(ovulation.getTime() + (266 + 3) * 86400000);
    } else {
        duedate.setTime(ovulation.getTime() + (266 + 8) * 86400000);
    }

    document.getElementById('dpacc').innerHTML = dispDate(duedate);

    //calcul semaines aménhorrées/grossesse
    var SA = (today - (ovulation.getTime() - (cycle - 14) * 86400000)) / 86400000;
    var SG = (today - ovulation.getTime()) / 86400000;

    var weeksSA = parseInt(SA / 7); // semaines entières

    var weeksSG = parseInt(SG / 7); // semaines entières

    // affichage durée en cours
    var ongoinggrossesse = duedate + 10 - today;
    var ongoingnid = ovulation - today;

    if (ongoingnid > -12 * 86400000 && ongoingnid < -1 * 86400000) {
        var dsemaine = 'Vous êtes peut-être enceinte, un test de grossesse vous le confirmera prochainement';
    } else if (ongoingnid > -1 * 86400000) {
        var dsemaine = "Vous n'êtes pas encore enceinte";
    } else if (ongoinggrossesse < 0) {
        var dsemaine = 'Cette grossesse est terminée';
    } else {
        var dsemaine =
            weeksSA +
            'è semaine d’aménorrhée<br>' +
            weeksSG +
            'è semaine de gestation';
    }
    if (weeksSA > 43) {
        dsemaine = 'Cette grossesse est terminée.';
    }

    chooseWeek(weeksSA);

    document.getElementById('titleSemaine').innerHTML = dsemaine;

    /**************** congé prénat    *****************/

    congeprenat = new Date();
    var dureecongeprenat = 6;
    var debutcongepre = 'Début du congé pré-natal';

    if (pariteg == '2P') {
        if (multipleg == '2E') {
            congeprenat.setTime(duedate.getTime() - 12 * 7 * 86400000);
            dureecongeprenat = 12;
            document.getElementById('dcpre3').innerHTML = ' - ' + debutcongepre;
            document.getElementById('dcpre1').innerHTML = '';
            document.getElementById('dcpre2').innerHTML = '';
            document.getElementById('dcpre4').innerHTML = '';
        } else if (multipleg == '3E') {
            congeprenat.setTime(duedate.getTime() - 24 * 7 * 86400000);
            dureecongeprenat = 24;
            document.getElementById('dcpre4').innerHTML = debutcongepre;
            document.getElementById('dcpre1').innerHTML = '';
            document.getElementById('dcpre2').innerHTML = '';
            document.getElementById('dcpre3').innerHTML = '';
        } else {
            congeprenat.setTime(duedate.getTime() - 8 * 7 * 86400000);
            dureecongeprenat = 8;
            document.getElementById('dcpre2').innerHTML = ' - ' + debutcongepre;
            document.getElementById('dcpre1').innerHTML = '';
            document.getElementById('dcpre3').innerHTML = '';
            document.getElementById('dcpre4').innerHTML = '';
        }
    } else {
        if (multipleg == '2E') {
            congeprenat.setTime(duedate.getTime() - 12 * 7 * 86400000);
            dureecongeprenat = 12;
            document.getElementById('dcpre3').innerHTML = ' - ' + debutcongepre;
            document.getElementById('dcpre1').innerHTML = '';
            document.getElementById('dcpre2').innerHTML = '';
            document.getElementById('dcpre4').innerHTML = '';
        } else if (multipleg == '3E') {
            congeprenat.setTime(duedate.getTime() - 24 * 7 * 86400000);
            dureecongeprenat = 24;
            document.getElementById('dcpre4').innerHTML = debutcongepre;
            document.getElementById('dcpre1').innerHTML = '';
            document.getElementById('dcpre2').innerHTML = '';
            document.getElementById('dcpre3').innerHTML = '';
        } else {
            congeprenat.setTime(duedate.getTime() - 6 * 7 * 86400000);
            dureecongeprenat = 6;
            document.getElementById('dcpre1').innerHTML = debutcongepre;
            document.getElementById('dcpre3').innerHTML = '';
            document.getElementById('dcpre2').innerHTML = '';
            document.getElementById('dcpre4').innerHTML = '';
        }
    }

    var descdureecongeprenat = dureecongeprenat + ' semaines';
    document.getElementById('prenat').innerHTML = dispDate(congeprenat);
    document.getElementById('dcongeprenat').innerHTML = descdureecongeprenat;

    /**************** fin congé prenat    *****************/

    /**************** congé post natal    *****************/

    congepostnat = new Date();
    var dureecongepostnat = 10;

    if (pariteg == '2P') {
        if (multipleg == '2E') {
            congepostnat.setTime(duedate.getTime() + 22 * 7 * 86400000);
            dureecongepostnat = 22;
        } else if (multipleg == '3E') {
            congepostnat.setTime(duedate.getTime() + 22 * 7 * 86400000);
            dureecongepostnat = 22;
        } else {
            congepostnat.setTime(duedate.getTime() + 18 * 7 * 86400000);
            dureecongepostnat = 18;
        }
    } else {
        if (multipleg == '2E') {
            congepostnat.setTime(duedate.getTime() + 22 * 7 * 86400000);
            dureecongepostnat = 22;
        } else if (multipleg == '3E') {
            congepostnat.setTime(duedate.getTime() + 22 * 7 * 86400000);
            dureecongepostnat = 22;
        } else {
            congepostnat.setTime(duedate.getTime() + 10 * 7 * 86400000);
            dureecongepostnat = 10;
        }
    }

    var descdureecongepostnat = dureecongepostnat + ' semaines';
    document.getElementById('postnat').innerHTML = dispDate(congepostnat);
    document.getElementById('dcongepostnat').innerHTML = descdureecongepostnat;

    /**************** fin congé post natal    *****************/

    /**************** durée congé mat    *****************/

    var dureecongemat = dureecongepostnat + dureecongeprenat;
    var descdureecongemat = dureecongemat + ' semaines au total';
    document.getElementById('dcongemat').innerHTML = descdureecongemat;

    /**************** fin durée congé mat    *****************/

    /**************** durée congé patho    *****************/

    congepatho = new Date();
    congepatho.setTime(congeprenat.getTime() - 2 * 7 * 86400000);
    document.getElementById('patho').innerHTML = dispDate(congepatho);

    /**************** fin durée patho    *****************/

    // array semaines de grossesse

    semainier = [];

    for (let i = 0; i < 47; i++) {
        semainier.push(new Date(ovulation.getTime() + i * 7 * 86400000));
        document.getElementById('SG' + i).innerHTML = dispDate(semainier[i]);
    }

    // date accouchement

    var acc1E,
        acc2E,
        acc3E,
        acc4P = '';
    if (multipleg == '1E' && pariteg == '0P') {
        acc1E = '';
        acc2E = '';
        acc3E = '';
        acc4P = 'Accouchement sinon ';
        document.getElementById('dacc1E').innerHTML = acc1E;
        document.getElementById('dacc2E').innerHTML = acc2E;
        document.getElementById('dacc3E').innerHTML = acc3E;
        document.getElementById('dacc4P').innerHTML = acc4P;
    } else if (multipleg == '2E') {
        acc2E = 'Accouchement pour une grossesse gémellaire - ';
        acc1E = '';
        acc3E = '';
        acc4P = '';
        document.getElementById('dacc1E').innerHTML = acc1E;
        document.getElementById('dacc2E').innerHTML = acc2E;
        document.getElementById('dacc3E').innerHTML = acc3E;
        document.getElementById('dacc4P').innerHTML = acc4P;
    }

    if (multipleg == '3E') {
        acc3E = 'Accouchement pour une grossesse de triplés et plus - ';
        acc2E = '';
        acc1E = '';
        acc4P = '';
        document.getElementById('dacc1E').innerHTML = acc1E;
        document.getElementById('dacc2E').innerHTML = acc2E;
        document.getElementById('dacc3E').innerHTML = acc3E;
        document.getElementById('dacc4P').innerHTML = acc4P;
    } else if (pariteg != '0P' && multipleg != '3E' && multipleg != '2E') {
        acc3E = '';
        acc2E = '';
        acc1E = 'Accouchement';
        acc4P = '';
        document.getElementById('dacc1E').innerHTML = acc1E;
        document.getElementById('dacc2E').innerHTML = acc2E;
        document.getElementById('dacc3E').innerHTML = acc3E;
        document.getElementById('dacc4P').innerHTML = acc4P;
    }

    return false; // form should never submit, returns false
}

function checkForm(form) {
    var inputs = form.querySelectorAll("input, select");
    var validated = true;
    for (var i = 0; i < inputs.length; i++) {
        var hasError = false;
        if (!inputs[i].value && inputs[i].nodeName.toLowerCase() !== 'select') {
            hasError = true;
        }
        if (inputs[i].nodeName.toLowerCase() === 'select' && inputs[i].dataset.int != undefined && isNaN(parseInt(inputs[i].value))) {
            hasError = true;
        }
        if (hasError) {
            inputs[i].classList.add('error');
            validated = false;
        } else {
            inputs[i].classList.remove('error');
        }
    }
    return validated;
}

function submitForm() {
    var form = document.getElementById("calendar-form");
    if (checkForm(form)) {
        grossesseElia(form);
        var targetElement = document.getElementById('printdate');
        targetElement.scrollIntoView({ behavior: 'smooth' });
    }
    else
        form.scrollIntoView({ behavior: 'smooth' });
}

function submitSubscribeForm() {
    var form = document.getElementById("calendar-form_subscribe");
    if (checkForm(form)) {
        printDiv();
    }
}

function updateValue(element, value, image = false) {
    const base_url = "//elia-lingerie.myshopify.com/cdn/shop/";

    if (value) {
        element.style.display = "block"
        image ? element.src = base_url + value : element.innerHTML = value;
    }
    else
        element.style.display = "none"
}

function chooseWeek(week, type = "pre") {
    const calendar = document.querySelector(`#calendrierSemaine`);
    const weeks = calendar.querySelectorAll(`td`);
    const weekItems = document.querySelectorAll(`div.calendar-weeks_item[data-type="${type}"]`);
    const choosen = document.querySelector(`div.calendar-weeks_item[data-week="${week}"][data-type="${type}"]`);
    let dsemaine = '';

    type == "pre" ?
        dsemaine = `${week}è semaine d’aménorrhée<br>${Math.max(0, week - 2)}è semaine de gestation`
        :
        dsemaine = `${week}è semaine post accouchement`

    document.getElementById('titleSemaine').innerHTML = dsemaine;

    if (type == "pre") {
        let postWeeks = document.querySelectorAll(`div.calendar-weeks_item[data-type="post"]`);
        postWeeks.forEach((item) => {
            item.classList.remove('past', 'active');
        });
        weeks.forEach((item) => {
            item.classList.remove('active');
            const itemWeek = parseInt(item.dataset.week);
            item.classList.toggle('active', week === itemWeek);
        });
    }
    else {
        let pretWeeks = document.querySelectorAll(`div.calendar-weeks_item[data-type="pre"]`);
        pretWeeks.forEach((item) => {
            item.classList.add('past');
            item.classList.remove('active');
        });
        weeks.forEach((item) => {
            item.classList.remove('active');
        });
    }

    weekItems.forEach((item) => {
        const itemWeek = parseInt(item.dataset.week);
        item.classList.toggle('past', week > itemWeek);
        item.classList.toggle('active', week === itemWeek);
    });

    if (choosen) {
        document.querySelector('.calendar_content').style.display = 'flex'
        let data = choosen.dataset

        if (data.size && data.weight && data.comparison) {
            document.querySelector('.calendar_content-summary').style.display = "block";
            updateValue(document.getElementById('imageSemaine'), data.image, true);
            updateValue(document.getElementById('sizeSemaine'), data.size);
            updateValue(document.getElementById('weightSemaine'), data.weight);
            updateValue(document.getElementById('comparisonSemaine'), data.comparison);
        }
        else {
            document.querySelector('.calendar_content-summary').style.display = "none";
        }
        if (data.icon1 || data.icon2 || data.icon3)
            document.querySelector('.calendar_content-icons-wrapper').style.display = "flex";
        else
            document.querySelector('.calendar_content-icons-wrapper').style.display = "none";

        updateValue(document.getElementById('icon1Semaine'), data.icon1, true);
        updateValue(document.getElementById('icon2Semaine'), data.icon2, true);
        updateValue(document.getElementById('icon3Semaine'), data.icon3, true);
        updateValue(document.getElementById('text1Semaine'), data.text1);
        updateValue(document.getElementById('text2Semaine'), data.text2);
        updateValue(document.getElementById('text3Semaine'), data.text3);
        updateValue(document.getElementById('descSemaine'), data.desc);

        const nextButton = document.getElementById('nextSemaine');
        if (type == "pre" && week < 40) {
            nextButton.style.display = "inline-flex";
            nextButton.innerHTML = `VOIR LA SEMAINE N°${week + 1}`;
            nextButton.dataset.week = week + 1;
            nextButton.addEventListener('click', handleClick);
        }
        else
            nextButton.style.display = "none";
    }
}

function handleClick(event) {
    event.preventDefault();
    const element = event.currentTarget;
    chooseWeek(parseInt(element.dataset.week), element.dataset.type);
    var targetElement = document.getElementById('calendar_content');
    targetElement.scrollIntoView({ behavior: 'smooth' });
}

const calendarElements = document.querySelectorAll('td[data-week]');
calendarElements.forEach((element) => {
    element.addEventListener("click", handleClick);
});

const calendarItems = document.querySelectorAll('.calendar-weeks_item');
calendarItems.forEach((element) => {
    element.addEventListener("click", handleClick);
});

window.addEventListener("load", function () {
    waitForElm('input.needsclick').then(() => {
        const inputElement = document.querySelector('input.needsclick');
        const buttonElement = document.querySelector('button.needsclick');
        let email = '';

        inputElement.addEventListener('input', function () {
            if (isValidEmail(inputElement.value)) {
                buttonElement.removeAttribute('disabled');
                email = inputElement.value;
            } else {
                buttonElement.setAttribute('disabled', true);
            }
        });

        buttonElement.addEventListener('click', function () {
            var inputDate = document.querySelector("input[name='date']").value;
            var parts = inputDate.split('-');
            var formattedDate = parts[2] + '/' + parts[1] + '/' + parts[0];
            klaviyo.push(['identify', {
                'email': email,
                'Accouchement': document.getElementById('dpacc').textContent,
                [document.querySelector("select[name='event'] option:checked").textContent]: formattedDate
            }]);
            printDiv();
        });

        buttonElement.setAttribute('disabled', true);
    });
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
}